import ApiCalls from './util/ApiCalls';

class ArchivedJourneyActionItemsService {
    async getForBrandJourney(brandJourneyId, queryParams) {
        return ApiCalls.defaultGet("/archived/action-item/" + brandJourneyId, queryParams);
    }
}
export default new ArchivedJourneyActionItemsService();